"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WARP_PULSE = exports.PASS_BY_LENGTH = exports.DEEP_RED_ALERT_LOOP_3 = exports.DEEP_RED_ALERT_LOOP_2 = void 0;
exports.getFlicker = getFlicker;
var _lightStyles = require("./lightStyles");
const WARP_PULSE = exports.WARP_PULSE = 10500;
const PASS_BY_LENGTH = exports.PASS_BY_LENGTH = 1000;
const DEEP_RED_ALERT_LOOP_2 = exports.DEEP_RED_ALERT_LOOP_2 = 3900;
const DEEP_RED_ALERT_LOOP_3 = exports.DEEP_RED_ALERT_LOOP_3 = 7800;

// TODO call this function every time flicker effect is used, not just at the beginning
function getFlicker(delay, lightStyleId = _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_VERY_LOW) {
  const FLICKER_LENGTH_MAX = 250;
  const FLICKER_LENGTH_MIN = 75;
  const randomFlickerLength = Math.floor(Math.random() * (FLICKER_LENGTH_MAX - FLICKER_LENGTH_MIN)) + FLICKER_LENGTH_MIN;
  return [{
    delay,
    style: lightStyleId
  }, {
    delay: delay + randomFlickerLength,
    style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
  }];
}